import { useMemo } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import MatchResultsView from "../MatchResultsView";
import {
  matchTypeMap,
  subTitleMap,
  topRankCountMap,
} from "../Individual/Individual";
import { MOCK_SCORE_ARRAYS } from "../Individual/mockScores";
import TournamentTop from "./TournamentTop";

// 전광판 (헤더/탭/검색 없이 표만 표시)
// - 예선: 점수 순 상위 5위
// - 본선: 16강 = 8강 진출자 8명(두 표), 8강 = 4강 진출자 4명, 4강 = 4명, 3·4위전·결승 = 두 선수 (TournamentTop)
// URL: /top5/:round/:category (경기결과 페이지와 같은 경로 이름)
// 예: /top5/individual_preliminaries/m-distance145, /top5/individual_round2/f-distance90
// 테스트: 주소 끝에 /test (예: /top5/individual_round16/m-distance145/test)

const View = ({ useMock = false }) => {
  const { round, category } = useParams();
  const [gender, distance] = category.split("-distance");

  // 렌더마다 새 배열이 생기면 MatchResultsView 의 useEffect 가 반복 실행되므로 memo
  const mockScoreArray = useMemo(
    () => (useMock ? MOCK_SCORE_ARRAYS[gender] : undefined),
    [useMock, gender]
  );

  if (round !== "individual_preliminaries") {
    return (
      <TournamentTop
        round={round}
        gender={gender}
        distance={distance}
        subTitle={subTitleMap[distance]}
        useMock={useMock}
      />
    );
  }

  return (
    <MatchResultsView
      matchType={matchTypeMap[round]}
      event={distance}
      gender={gender}
      subTitle={subTitleMap[distance]}
      topRankCount={topRankCountMap[round]}
      maxRows={5}
      compact
      mockScoreArray={mockScoreArray}
    />
  );
};

const Top5 = () => {
  return (
    <div className="contents top5">
      <Routes>
        <Route
          path="/"
          element={<Navigate to="individual_preliminaries/m-distance145" replace />}
        />
        <Route path=":round" element={<Navigate to="m-distance145" replace />} />
        <Route path=":round/:category" element={<View />} />
        {/* 테스트용 숨김 URL: 화면은 실제와 동일, 데이터만 가상 선수 */}
        <Route path=":round/:category/test" element={<View useMock />} />
      </Routes>
    </div>
  );
};
export default Top5;
